import { useState } from "react";
import styles from './PropertySelector.module.css';
import SingleSelectSearchableDropdown from "../../../Selectors/SingleSelectSearchableDropdown/SingleSelectSearchableDropdown";

const PropertySelector = ({
    userProperties,
    setShowPropertySelector,
    setGoogleAnalyticsProperty
}) => {

    const [currentlySelectedProperty, setCurrentlySelectedProperty] = useState(null);

    const handlePropertySelect = (property) => {
        setCurrentlySelectedProperty(property);
    };

    const handleConfirm = () => {
        if (currentlySelectedProperty) {
            setGoogleAnalyticsProperty(currentlySelectedProperty);
            // setShowAccountSelector(false);
            // setShowPropertySelector(true);
        }
    };

    const handleCancel = () => {
        setShowPropertySelector(false);
    };

    // Transform userProperties array to dropdown options format
    const propertyOptions = userProperties.map(property => ({
        id: property.name,
        displayText: property.displayName,
        label: property.name,
        iconText: `Region: ${property.regionCode} | Created: ${new Date(property.createTime).toLocaleDateString()}`
    }));

    return (
        <>
            <div className={styles.overlay} onClick={handleCancel} />
            <div className={styles.dialog}>
                <div className={styles.dialogHeader}>
                    <h3 className={styles.dialogTitle}>Choose Account</h3>
                </div>
                <div className={styles.dialogContent}>
                    <p className={styles.dialogDescription}>
                        Please select your Google Analytics account from the dropdown menu below.
                    </p>
                    <div className={styles.dropdownWrapper}>
                        <SingleSelectSearchableDropdown
                            fieldDisplayText="Select an account"
                            maxWidth={100}
                            maxWidthUnit="%"
                            listOptions={propertyOptions}
                            labelPosition="BELOW"
                            setSelectedOption={handlePropertySelect}
                        />
                    </div>
                </div>
                <div className={styles.dialogFooter}>
                    <button className={styles.cancelButton} onClick={handleCancel}>
                        Cancel
                    </button>
                    <button 
                        className={styles.confirmButton} 
                        onClick={handleConfirm}
                        disabled={!currentlySelectedProperty}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </>
    );
}

export default PropertySelector;